import { jsx } from "react/jsx-runtime";
import QuestionAnswerIcon from "@mui/icons-material/QuestionAnswer";
import { validateTidalLicense } from "../../base/index.js";
function QuestionAnswer(props) {
  return /* @__PURE__ */ jsx(
    QuestionAnswerIcon,
    {
      "data-testid": "QuestionAnswer",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "QuestionAnswer",
      "data-tidal-icon-meta": "chat,customerService"
    }
  );
}
QuestionAnswer.tidalIconMeta = {
  categories: "chat,customerService",
  name: "QuestionAnswer"
};
validateTidalLicense();
export {
  QuestionAnswer
};
//# sourceMappingURL=QuestionAnswer.js.map
